// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"Banner_bannerContainer__M6V_o","desktopBannerImage":"Banner_desktopBannerImage__z7klg","mobileBannerImage":"Banner_mobileBannerImage__PxKDl"};